export default __webpack_public_path__ + "static/title-box1-3c4bcdc23e76210d13ce3b16fdcacfc7.svg";